/* Shared laws catalog store. Same pattern as casesStore — the laws
 * catalog is a read-heavy list that changes rarely (admin-driven), so a
 * 30-second cache eliminates unnecessary refetches when the user hops
 * between /laws and other pages within the same session. */
import { listLaws } from "./api";
import { createListStore } from "./createListStore";

const store = createListStore({
  fetcher: listLaws,
  staleMs: 30_000,
  name: "laws",
});

export const fetchLaws = store.fetch;
export const prefetchLaws = store.prefetch;
export const invalidateLaws = store.invalidate;

export function useLaws() {
  const { data, loading, error, refresh } = store.useData();
  return {
    laws: data || [],
    loading,
    error,
    refresh,
  };
}
